/* tslint:disable */
/* eslint-disable */
/**
 * Bank API Schema
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @interface BulkInviteUsersAdminRequestUsersInner
 */
export interface BulkInviteUsersAdminRequestUsersInner {
    /**
     * Email address of the user to invite
     * @type {string}
     * @memberof BulkInviteUsersAdminRequestUsersInner
     */
    'email': string;
    /**
     * Full name of the user
     * @type {string}
     * @memberof BulkInviteUsersAdminRequestUsersInner
     */
    'name': string;
    /**
     * Account role for the user
     * @type {string}
     * @memberof BulkInviteUsersAdminRequestUsersInner
     */
    'role': BulkInviteUsersAdminRequestUsersInnerRoleEnum;
}

export const BulkInviteUsersAdminRequestUsersInnerRoleEnum = {
    generalUser: 'GENERAL_USER',
    organizationAdmin: 'ORGANIZATION_ADMIN',
    viewer: 'VIEWER',
    bookkeeper: 'BOOKKEEPER'
} as const;

export type BulkInviteUsersAdminRequestUsersInnerRoleEnum = typeof BulkInviteUsersAdminRequestUsersInnerRoleEnum[keyof typeof BulkInviteUsersAdminRequestUsersInnerRoleEnum];


